import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'
import { LocalDateTimeRange } from '@ftr/contracts/type/shared'
import { ApproximateTimeRange, DateComponent, DateFormat, TimeRange } from '@ftr/foundation'

@Component({
  standalone: true,
  selector: 'ftr-time-range-text',
  templateUrl: './time-range-text.component.html',
  imports: [DateComponent],
})
export class TimeRangeTextComponent implements OnChanges {
  @Input() timeRange: ApproximateTimeRange | TimeRange | LocalDateTimeRange
  @Input() showSeconds = false
  @Input() isOngoing = false
  @Input() divider = 'to'
  format = DateFormat.Time

  ngOnChanges(simpleChanges: SimpleChanges): void {
    if (simpleChanges.showSeconds) {
      this.format = this.showSeconds ? DateFormat.TimeWithSeconds : DateFormat.Time
    }
  }
}
